export default __webpack_public_path__ + "static/media/2018-AMcover.c9aa0abb.png";